<section class="col-seleccion">
  <router-outlet></router-outlet>  
</section>
<ticketing-resumen-venta *ngIf="getPuedoCargarDatos()"></ticketing-resumen-venta>
